// Module
var code = "<div class=\"bInputCheckbox\"> <label> <input type=\"checkbox\" ng-model=\"bInputCheckbox.data\"> <span class=\"checkbox\"><i ng-show=\"bInputCheckbox.data\" class=\"fa fa-check text-grey\"></i></span> <ng-transclude class=\"label\"></ng-transclude> </label> </div>";
// Exports
module.exports = code;